/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V2beta1PipelineTaskDetail } from './V2beta1PipelineTaskDetail';
import {
  V2beta1PipelineTaskDetailFromJSON,
  V2beta1PipelineTaskDetailFromJSONTyped,
  V2beta1PipelineTaskDetailToJSON,
  V2beta1PipelineTaskDetailToJSONTyped,
} from './V2beta1PipelineTaskDetail';

/**
 * Runtime details of a run.
 * @export
 * @interface V2beta1RunDetails
 */
export interface V2beta1RunDetails {
  /**
   * Pipeline context ID of a run.
   * @type {string}
   * @memberof V2beta1RunDetails
   */
  pipeline_context_id?: string;
  /**
   * Pipeline run context ID of a run.
   * @type {string}
   * @memberof V2beta1RunDetails
   */
  pipeline_run_context_id?: string;
  /**
   * Runtime details of the tasks that belong to the run.
   * @type {Array<V2beta1PipelineTaskDetail>}
   * @memberof V2beta1RunDetails
   */
  task_details?: Array<V2beta1PipelineTaskDetail>;
}

/**
 * Check if a given object implements the V2beta1RunDetails interface.
 */
export function instanceOfV2beta1RunDetails(value: object): value is V2beta1RunDetails {
  return true;
}

export function V2beta1RunDetailsFromJSON(json: any): V2beta1RunDetails {
  return V2beta1RunDetailsFromJSONTyped(json, false);
}

export function V2beta1RunDetailsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1RunDetails {
  if (json == null) {
    return json;
  }
  return {
    pipeline_context_id:
      json['pipeline_context_id'] == null ? undefined : json['pipeline_context_id'],
    pipeline_run_context_id:
      json['pipeline_run_context_id'] == null ? undefined : json['pipeline_run_context_id'],
    task_details:
      json['task_details'] == null
        ? undefined
        : (json['task_details'] as Array<any>).map(V2beta1PipelineTaskDetailFromJSON),
  };
}

export function V2beta1RunDetailsToJSON(json: any): V2beta1RunDetails {
  return V2beta1RunDetailsToJSONTyped(json, false);
}

export function V2beta1RunDetailsToJSONTyped(
  value?: V2beta1RunDetails | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pipeline_context_id: value['pipeline_context_id'],
    pipeline_run_context_id: value['pipeline_run_context_id'],
    task_details:
      value['task_details'] == null
        ? undefined
        : (value['task_details'] as Array<any>).map(V2beta1PipelineTaskDetailToJSON),
  };
}
